module.exports = __webpack_public_path__ + "static/media/bn_logo_sketches.bc692bf5.png";